import { Injector } from '@angular/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { RecipeComponent } from './recipe.component';
import { RECIPE_NODE_NAME, RECIPE_STEP_NODE_NAME } from './recipe.model';

const recipeClassName = 'recipe-block';

export const RecipeExtension = (injector: Injector) => {
  return Node.create({
    name: RECIPE_NODE_NAME,
    content: `${RECIPE_STEP_NODE_NAME}+`,
    group: 'block',
    defining: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        name: {
          default: '',
        },
        has_background: {
          default: true,
        },
        custom_css: {
          default: '',
        },
        custom_style: {
          default: null,
        },
        class: {
          renderHTML: (attributes) => {
            const otherClasses = ((attributes['class'] ?? '') as string)
              .split(' ')
              .filter((c) => c !== recipeClassName);
            return { class: `${recipeClassName} ${otherClasses.join(' ')}` };
          },
        },
      };
    },

    parseHTML() {
      return [{ tag: `div.${recipeClassName}` }];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: recipeClassName }, HTMLAttributes), 0];
    },

    addNodeView() {
      return AngularNodeViewRenderer(RecipeComponent, {
        injector,
        stopEvent: draggableNodeStopEvent,
      });
    },
  });
};
